<table mat-table [dataSource]="dataSource" class="full-width-table" matSort>

    <!-- ID Column -->
    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="col-id">ID</th>
        <td mat-cell *matCellDef="let element" class="col-id">
            {{element.id}}
        </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="col-loadname"> Account-Name</th>
        <td mat-cell *matCellDef="let element" class="col-loadname">
            {{element.name}}
        </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="vehicles">
        <th mat-header-cell *matHeaderCellDef class="col-loadname"> Fahrzeuge in diesem Account</th>
        <td mat-cell *matCellDef="let element" class="col-loadname">
            <div [innerHTML]="getVehiclesString(element)"></div>
        </td>
    </ng-container>

    <!-- actions -->
    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="col-actions"> </th>
        <td mat-cell *matCellDef="let element" class="col-actions">

            <button mat-icon-button (click)="updateList(element)" matTooltip="Fahrzeugliste neu laden"><mat-icon>sync</mat-icon></button>
            <button [disabled]="!element.canEdit" mat-icon-button (click)="refreshToken(element)" matTooltip="Token Erneuern"><mat-icon>vpn_lock</mat-icon></button>
            <button [disabled]="!element.canEdit" (click)="handleEditLoad(element)" mat-icon-button matTooltip="Bearbeiten"><mat-icon fontSet="material-icons">edit</mat-icon></button>
            <button [disabled]="!element.canDelete" (click)="handleDeleteLoad(element)" mat-icon-button matTooltip="Löschen"><mat-icon fontSet="material-icons">delete</mat-icon></button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator #paginator [length]="dataSource?.data.length" [pageIndex]="pageIndex" [pageSize]="pageSize"
               [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
</mat-paginator>
